/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import AnimateHeight from "react-animate-height";

import classnames from "classnames";
import { FAQ } from "./types/faq";
import styles from "./FAQItem.module.scss";

type Props = {
  faq: FAQ;
  isOpenInitially: boolean;
  dividerColor?: string;
};

export const FAQItem: React.FC<Props> = ({
  faq,
  isOpenInitially,
  dividerColor,
}) => {
  const [height, setHeight] = useState(isOpenInitially ? "auto" : 0);
  const isOpen = height !== 0;
  const cls = classnames(styles.faqsListItem, {
    [styles.faqsListItemActive]: isOpen,
    [styles.faqsListItemMistDivider]: dividerColor === "MIST_DARK",
  });

  //TODO: Replace this with React Aria useMenuTrigger() as React-Axe complaining

  return (
    <li className={cls}>
      {/*eslint-disable-next-line jsx-a11y/click-events-have-key-events*/}
      <h4
        aria-label="toggle faq"
        // role="switch"
        // aria-checked={isOpen}
        onClick={() => setHeight(isOpen ? 0 : "auto")}
        className={styles.faqsListItemTitle}
        title={isOpen ? "Hide the answer" : "Show the answer"}
      >
        {faq.question}
      </h4>
      <AnimateHeight height={height} duration={400}>
        {typeof faq.answer === "string" ? (
          <div
            className={styles.faqsListItemText}
            dangerouslySetInnerHTML={{ __html: faq.answer }}
          />
        ) : (
          <div>{faq.answer}</div>
        )}
      </AnimateHeight>
      <button
        className={styles.faqsListItemButton}
        onClick={(e) => {
          e.preventDefault();
          e.currentTarget.blur();
          setHeight(isOpen ? 0 : "auto");
        }}
        title={isOpen ? "Hide the answer" : "Show the answer"}
      />
    </li>
  );
};
